import * as React from 'react';
import classNames from 'classnames';

const prefix = 'ui-mobile-select';

export interface OptionProps {
  value: string | number;
  label?: any;
  children?: any;
  onClick?: (value: any, label: any) => void;
  selected?: string | number;
  selectedIcon?: any;
}
export interface OptionStates {}
export default class Option extends React.Component<OptionProps, OptionStates> {
  constructor(props: OptionProps) {
    super(props);
  }
  onClick = () => {
    const { onClick, value, children, label } = this.props;
    if (onClick) {
      const text = label || children;
      onClick(value, text);
    }
  };
  render() {
    const { selected, value, children, label, selectedIcon } = this.props;
    const text = label || children;
    const className = classNames([`${prefix}-option`, { 'option-active': selected === value }]);
    return (
      <li className={className} key={value} onClick={this.onClick}>
        {text}
        <div className={`${prefix}-selected-icon`}>{selectedIcon}</div>
      </li>
    );
  }
}
